export default __webpack_public_path__ + "static/media/p_wdt_c_5.4f16dff1.mp3";